export const STATUS = {
    PENDING: 'Pending',
    ACCEPTED: 'Accepted'
}

export const RESPONSE_STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    VALIDATION_ERROR: 'validationError',
    UNAUTHORIZED: 'unauthorized'
}